export default __webpack_public_path__ + "static/media/03n.380db1fe.jpg";